const cacheKeys = {
  all: ['ads'],
  small: () => [...cacheKeys.all, 'small'],
  big: () => [...cacheKeys.all, 'big'],
  welcomeAd: () => [...cacheKeys.all, 'welcomeAd'],
  survey: () => [...cacheKeys.all, 'survey']
}

export default {
  endpoints: {
    small: (networkId) => `/community/${networkId}/bottom-stories-banners`,
    big: (networkId) => `/community/${networkId}/sliding-top-banners`,
    welcomeAd: (networkId) => `/community/${networkId}/welcome-ads`,
    survey: (networkId) => `/community/${networkId}/surveys`,
    replySurvey: `/unity-answer`
  },
  cacheKeys
}
